(function () {

    angular
        .module("ROGER")

        .controller("ApprovalReturnController", [
            "$scope",
            function (scope) {
                scope.description = null;

                scope.return = function () {
                    scope.$close(scope.description);
                }

                scope.cancel = function () {
                    scope.$dismiss();
                }
            }
        ]);
})();